/* ==========================================================================
   Statement Denim — shop page

   Client-side category filter, sort and density switch over the products on the
   page, plus the quick-view drawer and its real add-to-cart.
   ========================================================================== */
(function () {
  'use strict';

  var SD = window.SD || {};

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var shop = document.querySelector('[data-sd-shop]');
    var bar = document.querySelector('[data-sd-filterbar]');
    if (!shop) return;

    var grid = shop.querySelector('[data-sd-grid]');
    var items = [].slice.call(shop.querySelectorAll('[data-sd-item]'));
    var countEl = bar && bar.querySelector('[data-sd-count]');
    var shownEl = shop.querySelector('[data-sd-shown]');
    var emptyEl = shop.querySelector('[data-sd-empty]');
    var sortEl = bar && bar.querySelector('[data-sd-sort]');

    /* Chip handlers are scoped to the filter bar. Card markup uses
       data-sd-pcat, never data-sd-cat, for the same reason. */
    var catBtns = bar ? [].slice.call(bar.querySelectorAll('[data-sd-cat]')) : [];
    var densBtns = bar ? [].slice.call(bar.querySelectorAll('[data-sd-dens]')) : [];

    var cat = 'all';
    var sortMode = 'new';
    var density = +(shop.getAttribute('data-sd-density') || 3);

    function mark(list, active) {
      list.forEach(function (b) {
        var on = b === active;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    var comparators = {
      low: function (a, b) {
        return a.getAttribute('data-sd-price') - b.getAttribute('data-sd-price');
      },
      high: function (a, b) {
        return b.getAttribute('data-sd-price') - a.getAttribute('data-sd-price');
      },
      name: function (a, b) {
        return a.getAttribute('data-sd-name').localeCompare(b.getAttribute('data-sd-name'));
      },
      new: function (a, b) {
        return a.getAttribute('data-sd-order') - b.getAttribute('data-sd-order');
      },
    };

    function apply() {
      var visible = items.filter(function (el) {
        return cat === 'all' || el.getAttribute('data-sd-pcat') === cat;
      });

      items.forEach(function (el) {
        el.hidden = visible.indexOf(el) === -1;
      });

      visible.slice().sort(comparators[sortMode]).forEach(function (el) {
        grid.appendChild(el);
      });

      if (countEl) {
        countEl.textContent = visible.length + (visible.length === 1 ? ' piece' : ' pieces');
      }
      if (shownEl) {
        shownEl.textContent = 'Showing ' + visible.length + ' of ' + items.length;
      }
      if (emptyEl) emptyEl.hidden = visible.length > 0;
      grid.hidden = visible.length === 0;

      if (SD.revealNow) SD.revealNow(visible, 38);
    }

    /* responsive floor overrides the chosen density so cards never crush */
    function fit() {
      var w = innerWidth;
      var cols = w < 620 ? 1 : w < 900 ? Math.min(density, 2) : density;
      grid.style.gridTemplateColumns = 'repeat(' + cols + ',minmax(0,1fr))';
    }

    catBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        cat = b.getAttribute('data-sd-cat');
        mark(catBtns, b);
        apply();
      });
    });

    densBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        density = +b.getAttribute('data-sd-dens');
        mark(densBtns, b);
        fit();
      });
    });

    if (sortEl) {
      sortEl.addEventListener('change', function (e) {
        sortMode = e.target.value;
        apply();
      });
    }

    addEventListener('resize', fit, { passive: true });
    fit();

    /* the cards render with the reveal start state already applied, so the
       first pass just staggers them in — no flash */
    apply();

    /* ── quick view ──────────────────────────────────────────────────── */

    var drawer = document.querySelector('[data-sd-drawer]');
    var scrim = document.querySelector('[data-sd-scrim]');
    if (!drawer) return;

    var qv = {
      image: drawer.querySelector('[data-sd-qv-image]'),
      noshot: drawer.querySelector('[data-sd-qv-noshot]'),
      meta: drawer.querySelector('[data-sd-qv-meta]'),
      name: drawer.querySelector('[data-sd-qv-name]'),
      price: drawer.querySelector('[data-sd-qv-price]'),
      optionLabel: drawer.querySelector('[data-sd-qv-optionlabel]'),
      sizes: drawer.querySelector('[data-sd-qv-sizes]'),
      stock: drawer.querySelector('[data-sd-qv-stock]'),
      add: drawer.querySelector('[data-sd-qv-add]'),
      full: drawer.querySelector('[data-sd-qv-full]'),
    };

    var current = null;
    var chosen = null;
    var lastFocus = null;

    /* Pre-launch: the drawer's buy button is an inert "Coming soon". open()
       below rewrites that button's label and re-enables it on every open, so
       it has to know not to. */
    var SOON = qv.add.hasAttribute('data-sd-soon');
    var SOON_LABEL = qv.add.getAttribute('data-sd-soon') || 'Coming soon';

    function hasRealOptions(data) {
      if (data.variants.length > 1) return true;
      var only = data.variants[0];
      return !!(only && only.option && only.option !== 'Default Title');
    }

    function renderSizes(data) {
      qv.sizes.innerHTML = '';
      chosen = null;

      if (!hasRealOptions(data)) {
        qv.sizes.hidden = true;
        qv.optionLabel.hidden = true;
        chosen = data.variants[0] || null;
        qv.stock.textContent = chosen && chosen.available ? 'In stock' : 'Sold out';
        qv.stock.classList.remove('is-warn');
        return;
      }

      qv.sizes.hidden = false;
      qv.optionLabel.hidden = false;
      qv.optionLabel.textContent = data.optionName || 'Size';

      data.variants.forEach(function (v) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sd-size';
        btn.textContent = v.option;
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('data-sd-cur', 'Pick');
        if (!v.available) btn.disabled = true;

        btn.addEventListener('click', function () {
          chosen = v;
          qv.sizes.querySelectorAll('.sd-size').forEach(function (o) {
            o.setAttribute('aria-pressed', o === btn ? 'true' : 'false');
          });
          qv.stock.textContent = SD.stockLine(v, data.optionName || 'Size');
          qv.stock.classList.remove('is-warn');
        });

        qv.sizes.appendChild(btn);
      });

      qv.stock.textContent = 'Select a ' + (data.optionName || 'size').toLowerCase();
      qv.stock.classList.remove('is-warn');
    }

    function open(data, trigger) {
      current = data;
      lastFocus = trigger || null;

      if (data.image) {
        qv.image.src = data.image;
        qv.image.alt = data.title;
        qv.image.hidden = false;
        qv.noshot.hidden = true;
      } else {
        qv.image.hidden = true;
        qv.noshot.hidden = false;
      }

      qv.meta.textContent = data.meta || '';
      qv.name.textContent = data.title;
      qv.price.innerHTML = data.price;
      qv.full.href = data.url;

      if (SOON) {
        qv.add.textContent = SOON_LABEL;
        qv.add.disabled = true;
      } else {
        qv.add.textContent = 'Add to bag';
        qv.add.classList.remove('is-added');
        qv.add.disabled = false;
      }

      renderSizes(data);

      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.classList.add('is-open');
      (SOON && qv.full ? qv.full : qv.add).focus({ preventScroll: true });
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.classList.remove('is-open');
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    }

    shop.querySelectorAll('[data-sd-quick]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var card = btn.closest('[data-sd-item]');
        var json = card && card.querySelector('script[data-sd-qv]');
        if (!json) return;
        try {
          open(JSON.parse(json.textContent), btn);
        } catch (err) {
          /* a malformed payload must not break the grid */
        }
      });
    });

    drawer.querySelector('[data-sd-drawer-close]').addEventListener('click', close);
    if (scrim) scrim.addEventListener('click', close);
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    qv.add.addEventListener('click', function () {
      if (SOON) return;
      if (!chosen) {
        qv.stock.textContent = 'Pick a size first';
        qv.stock.classList.add('is-warn');
        return;
      }

      qv.stock.classList.remove('is-warn');
      qv.add.disabled = true;

      SD.addToCart(chosen.id, 1)
        .then(function () {
          var suffix = hasRealOptions(current) ? ' — size ' + chosen.option : '';
          qv.add.textContent = 'Added' + suffix;
          qv.add.classList.add('is-added');
          setTimeout(close, 620);
        })
        .catch(function (err) {
          qv.add.disabled = false;
          qv.stock.textContent = (err && err.description) || 'Could not add — try again';
          qv.stock.classList.add('is-warn');
        });
    });
  });
})();
